import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { SectionHead } from "@/components/site/Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="section grid lg:grid-cols-12 gap-10">
    <div className="lg:col-span-4"><SectionHead eyebrow="FAQ" testid="faq-title" title={<>FAQ</>} /></div>
    <Accordion type="single" collapsible className="lg:col-span-8 space-y-3">
      {FAQS.map((f, i) => (
        <AccordionItem key={f.q} value={`f${i}`} className="rounded-2xl border border-white/10 bg-white/[0.03] px-6">
          <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg md:text-xl font-semibold tracking-tight hover:no-underline hover:text-[var(--accent)]">
            {f.q}
          </AccordionTrigger>
          <AccordionContent data-testid={`faq-answer-${i}`} className="text-slate-400 text-base leading-relaxed pb-6 max-w-2xl">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
